<template>
  <div
    class="fx__active"
    @mouseenter="isShow = true"
    @mouseleave="isShow = false"
    @click="routerTo(Menu.name)"
    style=" transition: all 0.2s;
    -webkit-user-select:none;
   -moz-user-select:none;
   -ms-user-select:none;
   user-select:none; "
    :class=" IsFold ? 'link_change' : 'link' "
  >
    <!-- ding按钮 -->
    <!-- <i class="fa fa-thumb-tack isShow" v-show="isShow || Menu.isDing" @click.stop="addMenus"></i> -->
    
      <div
        :class="[ Menu.name, IsFold ?'icon_change':  'icon'  ]"
        :style="{ background: (Menu.iconbg ? Menu.iconbg : '') }"
      >
        <!-- 自定义的svg -->
        <svg-icon :iconClass="Menu.svg" v-if="Menu.svg" class="item_icon fa-lg"></svg-icon>
        <!-- 自定义的icon -->
        <i v-else-if="Menu.icon" :class=" Menu.icon "></i>
        <!-- 默认 -->
        <i v-else class="fa fa-circle fa-lg"></i>
      </div>
      <div class="textBox" v-show="!IsFold ">
        <div class="menuText fx__text_headline fx__simpleline">{{ Menu.text }}</div>
        <div class="menuDesc fx__text_assist" :title="Menu.description">{{ Menu.description }}</div>
      </div>
    
    <!-- <div v-show=" Menu.IsFold " :class="{ 'tooltip_text': Menu.IsFold }">
      <span style="color: rgb(248, 241, 241)">{{ Menu.text }}</span>
      <span class="fa fa-caret-down tooltip_icon"></span>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    Menu: Object,
    IsFold: Boolean
  },
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    routerTo(name) {
      this.$app.routeMenuTo(name);
    },
    // addMenus() {
    //   this.$emit("on-ding", this.Menu);
    // }
  }
};
</script>

<style lang="scss" scoped>
.tooltip_text {
  position: absolute;
  display: none;
  padding: 5px;
  width: 100px;
  height: 35px;
  top: -43px;
  left: 38px;
  z-index: 3;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.6);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
  span {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tooltip_icon {
    position: absolute;
    bottom: -9px;
    left: 10px;
    color: rgba(19, 19, 19, 0.5);
  }
}
.icon_change {
  width: 35px;
  height: 35px;
  background: -webkit-linear-gradient(
    left,
    rgb(98, 184, 102),
    rgb(72, 164, 76)
  );
  background: linear-gradient(to right, rgb(98, 184, 102), rgb(72, 164, 76));
  color: #ffffff;
  border-radius: 32px;
  // animation:mychange 0.2s alternate 1;
  font-size: 15px;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
// @keyframes mychange
// {
//     from {transform: rotate(60deg);}
//     to {transform: rotate(0);}
// }
// @keyframes mychange2
// {
//     from {transform: rotate(-45deg);}
//     to {transform: rotate(0);}
// }
.icon {
  width: 40px;
  height: 40px;
  background: -webkit-linear-gradient(
    left,
    rgb(98, 184, 102),
    rgb(72, 164, 76)
  );
  // animation:mychange2 0.4s alternate 1;
  background: linear-gradient(to right, rgb(98, 184, 102), rgb(72, 164, 76));
  color: #ffffff;
  border-radius: 16px;
  font-size: 16px;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.link_change {
  padding: 10px;
  cursor: pointer;
  position: relative;
  margin: 0 0 10px 0;
  border-radius: 8px;
  .isShow {
    font-size: 16px;
    height: 18px;
    transform: rotate(-45deg);
    position: absolute;
    top: 0;
    left: 8px;
    &:active {
      color: #51acfe;
    }
  }
  &:hover .tooltip_text {
    display: flex;
  }
}
.link {
  display: flex;
  flex-flow: column nowrap;
  align-content: center;
  align-items: center;
  width: 25%;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 0 10px 0;
  position: relative;
  padding-right: 10px;
  &:active {
    .menuText {
      color: #51acfe;
    }
  }
  .textBox {
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 10px;
    // width: calc(100% - 68px);
    .menuText {
      width: 85px;
      text-align: center;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      font-size: 14px;
      font-weight: bold;
    }
    .menuDesc {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      max-height: 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .isShow {
    font-size: 24px;
    height: 30px;
    transform: rotate(-45deg);
    position: absolute;
    top: 0;
    left: 10px;
    &:hover {
      color: #51acfe;
    }
  }
}
.item_icon {
  width: 34px;
  height: 34px;
}
// @media screen and (max-width: 1200px) {
//   .link {
//     width: 33.33%;
//   }
// }
// @media screen and (max-width: 992px) {
//   .link {
//     width: 48.5%;
//     padding-right: 0;
//   }
// }
</style>